<template>
  <f7-page no-toolbar no-swipeback name="financial" class="page-center">
    <f7-navbar innerClass="navbar-inner">
      <f7-nav-left>
        <f7-link @click="$f7router.navigate('/home/')">
          <i class="f7-icons" style="color: white">chevron_left</i>
        </f7-link>
      </f7-nav-left>
      <f7-nav-title>{{ $t("bonusv1_01") }}</f7-nav-title>
      <f7-nav-right>
        <f7-link></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <div class="content">
      <van-swipe class="my-swipe" :loop="false"  v-if="bonus.SubEventsSettings"  @change="onChange">
        <van-swipe-item v-if="bonus.SubEventsSettings.EnableBonus_For_ContinueToUpgradeVIP">
          <div class="caption">
            <div class="c1">{{ $t("bonusv1_02") }}</div>
            <div class="c2">{{ bonus.BeginTS | time }} ~ {{ bonus.EndTS | time }}</div>
            <div class="c3">{{ $t("bonusv0_05") }}</div>
            <div class="c4">{{ $t("bonusv1_03") }}</div>
          </div>
        </van-swipe-item>
        <van-swipe-item v-if="bonus.SubEventsSettings.EnableBonus_For_SubordinateMemberFirstTimeActiveVIP">
          <div class="caption">
            <div class="c1">{{ $t("bonusv1_05") }}</div>
            <div class="c2">{{ bonus.BeginTS | time }} ~ {{ bonus.EndTS | time }}</div>
            <div class="c3">{{ $t("bonusv0_05") }}</div>
            <div class="c4">{{ $t("bonusv1_06") }}</div>
          </div>
        </van-swipe-item>
      </van-swipe>

      <div v-for="(item, index) in simpleVipList" :key="index" v-show="vanIndex==0">
        <div class="onemore" v-show="!item.BonusForContinueToUpgradeVIP_HideForMember">
          <div class="top">
            <div class="left">{{ item.Name.toUpperCase() }}</div>
            <div class="right">
              <img src="../static/images/yt999/zhu.png" alt="" srcset="" style="height: 25px; margin-right: 10px" />
              <span v-if="item.BonusForContinueToUpgradeVIP_BonusAmountType == 1">{{ currencySymbol }} {{ item.BonusForContinueToUpgradeVIP_FixedBonusAmount | formatCurrency }}</span>
              <span v-else>{{ currencySymbol }} {{ item.BonusForContinueToUpgradeVIP_MinBonusAmountForText | formatCurrency }} - {{ currencySymbol }} {{ item.BonusForContinueToUpgradeVIP_MaxBonusAmountForText | formatCurrency }}</span>
            </div>
          </div>
          <div v-if="item.BonusForContinueToUpgradeVIP_Enable" class="go" @click="getOne(item.Id)">{{ $t("bonusv0_07") }}</div>
          <div v-else class="go nogo">{{ $t("bonusv1_04") }}</div>
        </div>
      </div>
      <div v-for="(item) in simpleVipList" :key="item.Id" v-show="vanIndex==1">
        <div class="onemore" v-show="item.BonusForSubordinateMemberFirstTimeActiveVIP_Enable">
          <div class="top">
            <div class="left">{{ item.Name.toUpperCase() }}</div>
            <div class="right">
              <img src="../static/images/yt999/zhu.png" alt="" srcset="" style="height: 25px; margin-right: 10px" />
              <span v-if="item.BonusForSubordinateMemberFirstTimeActiveVIP_BonusAmountType == 1">{{ currencySymbol }} {{ item.BonusForSubordinateMemberFirstTimeActiveVIP_FixedBonusAmount | formatCurrency }}</span>
              <span v-else>{{ currencySymbol }} {{ item.BonusForSubordinateMemberFirstTimeActiveVIP_MinBonusAmountForText | formatCurrency }} - {{ currencySymbol }} {{ item.BonusForSubordinateMemberFirstTimeActiveVIP_MaxBonusAmountForText | formatCurrency }}</span>
            </div>
          </div>
        </div>
      </div>

    </div>

    <van-popup v-model="vanflag" class="van">
      <div class="">
        <div><img :src="`../static/images/yt999/home/ico/ZZicon/${selectId}.png`" alt="" height="90px" /></div>
        <div class="f1">
          {{ $t("vip_detail_0018") }}
          <span style="color: var(--f7-THEME-color)">{{ backData.TargetVIPLevelName }}</span>
        </div>
        <div v-if="backData.BonusForFirstTimeBecomeVIP_Show">
          <div>{{ $t("bonusv0_01") }}</div>
          <div class="f3">
            <span style="font-size: 12px">{{ currencySymbol }}</span>
            {{ backData.BonusForFirstTimeBecomeVIP_Amount | formatCurrency }}
          </div>
          <div>{{ $t("bonusv0_02") }}</div>
        </div>

        <div class="go" @click="closevanFlag()">{{ $t("common_0001") }}</div>
      </div>
    </van-popup>

    <van-popup v-model="vantshow" position="bottom" class="vanbuy">
      <div class="sheet-modal-swipe-step">
        <div class="display-flex justify-content-space-between align-items-center buypopup">
          <div class="yiban one">
            <div style="font-size: 18px; line-height: 37px">{{ $t("vip_detail_0010") }}</div>
            <div style="position: relative; text-align: right">
              <i class="f7-icons" style="color: yellow" id="add" @click="topUp()">plus_circle</i>
              <div class="yuer">
                <span class="">{{ $t("vip_detail_0011") }}</span>
                <br />
                <span>
                  <span class="symbol">{{ currencySymbol }}</span>
                  {{ memberBalance | formatCurrency }}
                </span>
              </div>
            </div>
          </div>
          <div class="paddding" style="font-size: 18px">{{ $t("vip_detail_0012") }} {{ vipInfo.Name }}</div>
          <div class="yiban two paddding">
            <div style="color: #707070">{{ $t("vip_detail_0013") }} {{ vipInfo.VIPAmountLockDays }}</div>
          </div>
          <div class="yiban three paddding">
            <div style="color: #707070">{{ $t("vip_detail_0014") }}</div>
            <div style="color: #0887b2">
              <span class="symbol">{{ currencySymbol }}</span>
              {{ vipInfo.DepositTotalAmount | formatCurrency2 }}
            </div>
          </div>
          <div class="yiban four paddding price">
            <div>
              <span>{{ $t("vip_detail_0016") }}</span>
              <span style="color: #0887b2; font-size: 18px">{{ currencySymbol }}&nbsp;{{ vipInfo.DepositTotalAmount | formatCurrency2 }}</span>
            </div>
            <div class="paybtn" @click="vipLevelUpdateMethod(vipInfo.Id)">{{ $t("vip_detail_0017") }}</div>
          </div>
        </div>
      </div>
    </van-popup>
  </f7-page>
</template>

<script>
import { getCookie, getStore } from "@/config/utils";
import { getBalancesDetail, getsimpleviplist, checkRegulaVipEvent, vipLevelUpdate } from "../axios/api";

export default {
  components: {},
  props: {},
  data() {
    return {
      vanflag: false,
      currencySymbol: getStore("currencySymbol"),
      vantshow: null,
      memberBalance: 0,
      vipInfo: {
        Name: "",
      },
      bonus: {},
      simpleVipList: [],
      backData: {},
      selectId: 0,
      vanIndex: -1,
    };
  },
  watch: {},
  computed: {},
  methods: {
    onChange(index) {
      this.vanIndex = index;
    },
    closevanFlag() {
      this.vanflag = false;
    },
    topUp() {
      this.$f7.sheet.close();
      this.$f7router.navigate("/member-center/deposit/");
    },
    getsBalancesDetail() {
      getBalancesDetail().then((data) => {
        if (data.Code === "NoError") {
          const res = data.Data;
          this.memberBalance = data.Data.Balance;
        }
      });
    },
    getSimpleVipList() {
      const self = this;
      const params = {"ShowDefault":true};
      let d = JSON.stringify(params);
      getsimpleviplist(d).then((data) => {
        if (data.Code === "NoError") {
          self.simpleVipList = data.Data;
        }
      });
    },
    getOne(id) {
      const self = this;
      self.simpleVipList.forEach((item, index) => {
        item.Name = item.Name.toUpperCase();
        if (item.Id == id) {
          self.vipInfo = item;
          self.vantshow = true;
        }
      });
    },
    checkRegulaVipEvent() {
      const self = this;
      checkRegulaVipEvent().then((data) => {
        if (data.Code === "NoError") {
          self.bonus = data.Data;
          if(data.Data.SubEventsSettings.EnableBonus_For_ContinueToUpgradeVIP){
            self.vanIndex = 0;
          }else if(data.Data.SubEventsSettings.EnableBonus_For_SubordinateMemberFirstTimeActiveVIP){
            self.vanIndex = 1;

          }
        }
      });
    },
    vipLevelUpdateMethod(id) {
      const self = this;
      self.vantshow = false;
      self.selectId = id;
      const params = {
        TargetVIPLevelID: id,
      };
      let d = { data: JSON.stringify(params) };
      vipLevelUpdate(d).then((data) => {
        if (data.Code === "NoError") {
          self.backData = data.Data;
          self.vanflag = true;
          self.getSimpleVipList();
        } else {
          self.$f7.dialog.alert(data.Data, this.$t("common_0004"));
        }
      });
    },
  },
  created() {
    this.getsBalancesDetail();
    this.getSimpleVipList();
    this.checkRegulaVipEvent();
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
::v-deep .navbar-inner {
  //头部颜色更换
  color: white;
  background: linear-gradient(to right, var(--f7-THEME-colorbg), #0887b2);
}
::v-deep .page-content::after {
  height: 0;

}
.content {
  padding: 10px;
  min-height: 98%;
  background: var(--f7-THEME-color2);
  background-image: url(../static/images/yt999/member_center_bg.png);
  background-repeat: no-repeat;
  background-size: 100% 12%;
  .caption {
    width: 85%;
    margin: 0 auto;
    background: white;
    border-radius: 10px;
    padding: 20px;
    text-align: center;
    .c1 {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 7px;
      height: 40px;
    }
    .c2 {
      color: #848484;
      font-weight: bold;
      font-size: 12px;
      padding-bottom: 15px;
      border-bottom: 1px solid #e5e5e5;
    }
    .c3 {
      padding: 15px 0;
      font-weight: bold;
    }
    .c4 {
      text-align: left;
      height: 100px;
    }
  }
  .onemore {
    background: white;
    border-radius: 10px;
    padding: 20px;
    width: 85%;
    margin: 0 auto;
    margin-top: 15px;
    .top {
      display: grid;
      grid-template-columns: 20% 80%;
      align-items: center;
      .left {
        font-size: 18px;
        font-weight: bold;
      }
      .right {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-weight: bold;
      }
    }
    .go {
      width: 100%;
      height: 40px;
      line-height: 40px;
      background: var(--f7-THEME-color);
      border-radius: 10px;
      color: white;
      font-weight: bold;
      text-align: center;
      margin: 15px auto 0px auto;
    }
    .nogo {
      background: #ccc;
    }
  }
  .my-swipe{
    .van-swipe-item{
      // width: 48%!important;
      // margin: 1%;
      
    }
    ::v-deep .van-swipe__indicator{
      background: #363229;
    }
    ::v-deep .van-swipe__indicator--active{
      background: var(--f7-THEME-color)!important;;
    }
  }
}
.van {
  width: 65%;
  border-radius: 20px;
  text-align: center;
  padding: 15px;
  .f1 {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .f3 {
    font-size: 20px;
    font-weight: bold;
    margin: 10px 0;
    color: var(--f7-THEME-color);
  }
  .go {
    width: 70%;
    height: 40px;
    line-height: 40px;
    background: var(--f7-THEME-color);
    margin: 20px auto 10px auto;
    border-radius: 10px;
    color: white;
    font-weight: bold;
  }
}
.vanbuy {
  border-radius: 20px 20px 0 0;
  // padding-bottom: 55px;
}
.buypopup {
  display: block !important;
  padding: 0px !important;

  #add {
    position: absolute;
    right: 25px;
    top: 5px;
    font-size: 23px;
  }
  .yuer {
    width: 100%;
    position: absolute;
    right: 60px;
  }
  .yiban {
    display: flex;

    div {
      width: 50%;
    }
    div:nth-child(1) {
      width: 40%;
    }

    div:nth-child(2) {
      width: 70%;
    }
  }

  .paddding {
    padding: 10px;
    margin: 10px;
    padding: 5px;
    border-bottom: 1px solid #e1e0e0;

    div:nth-child(2) {
      text-align: right;
    }
  }
  .price {
    span {
      width: 50px;
      height: 20px;
      display: block;
      text-align: center;
      line-height: 20px;
      border-radius: 10px;
      border: 1px solid var(--f7-THEME-color);
      margin: 0px 3px;
    }
  }
  .one {
    background: var(--f7-THEME-color);
    color: white;
    padding: 11px 0 7px 28px;
  }

  .four {
    border: none;
    padding: 10px 0 13px 20px;

    span {
      border: none;
    }
  }

  .paybtn {
    text-align: center !important;
    line-height: 36px;
    border-radius: 20px;
    background: var(--f7-THEME-color);
    height: 36px;
    color: #ffffff;
    font-size: 16px;
    width: 113px !important;
    margin-left: 25%;
    margin-top: 3px;
  }
}
</style>
